import { useCalculatorContext } from "../contexts/CalculatorContext"

export default function CurrencySelect(param) {
    const { currency, setCurrency } = useCalculatorContext()

    return (
        <div style={{ display: 'inline-flex', margin: '0px 3px' }}>
            <select
                style={{
                    padding: '1px 5px',
                    backgroundColor: '#F2F3F5',
                    border: 'none',
                    borderRadius: '7px'
                }}
                name="currencySelect"
                value={currency}
                id="currencySelect"
                onChange={(option) => {
                    setCurrency(option.target.value)
                }}
            >
                <option value="EUR">EUR</option>
                <option value="USD">USD</option>
            </select>
        </div>
    )
}